'use client';

import { Hash } from 'lucide-react';

interface MetadataSectionProps {
  semanticId: string | null | undefined;
}

export function MetadataSection({ semanticId }: MetadataSectionProps) {
  if (!semanticId) {
    return null;
  }

  return (
    <div className="pt-2 border-t border-border/30">
      <div className="flex items-center gap-1.5">
        <Hash className="h-3 w-3 text-muted-foreground/60" />
        <code className="text-[10px] font-mono text-muted-foreground/60">
          {semanticId}
        </code>
      </div>
    </div>
  );
}
